import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Component({
  selector: 'app-export-csv',
  templateUrl: './export-csv.component.html',
  styleUrls: ['./export-csv.component.css']
})
export class ExportCsvComponent implements OnInit {

  NAME_FILE_EXPORT = "Export-Csv.csv";

  formulario: FormGroup;
  dataBody: any[] = [];
  dataHead: any[] = [];
  dataJson: any[] = [];

  constructor(public fb: FormBuilder, private _util: UtilsService) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      multipart: [''],
    });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
        this.formulario.get('multipart').setValue(file);
      }
  }

  readFileContent(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        if (!file) {
            resolve('');
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            const text = reader.result.toString();
            resolve(text);
        };
        reader.readAsText(file);
    });
}
  
  async procesar() {
    // debugger
    this.dataBody = [];
    this.dataHead = [];
    this.dataJson = [];
    let file = this.formulario.get('multipart').value;
    let str = await this.readFileContent(file);
    this.dataJson = JSON.parse(str);
    if(this.dataJson.length > 0) {
      let objCab = this.dataJson[0];
      let listCab = [];
      for (const property in objCab) {
        listCab.push(property);
      }
      this.dataHead.push(listCab);
      this.dataBody = this.dataJson;
      this._util.exportCSV(this.dataHead, this.dataBody, this.NAME_FILE_EXPORT);
    } else {
      this._util.mensajeErrorVisto('Se produjo un error!!');
    }
    console.log(this.dataJson);
  }

}
